import ModelService from "../../base/ModelService";

class Asset extends ModelService {
  constructor() {
    super('admin/assets');
  }
}

export default new Asset();
